export default __webpack_public_path__ + "static/media/wanna2.de816ab7.webp";